import { identityInstance } from './identity-instance';

export type ProveFlowType = 'mobile' | 'desktop';

export interface ProvePrefillInitializeInput {
  flowType: ProveFlowType;
  dateOfBirth?: {
    day: number;
    month: number;
    year: number;
  };
  phoneNumber?: string;
  finalTargetUrl?: string;
}

export interface ProvePrefillInitializeResponse {
  authToken: string;
}

export interface ProvePrefillVerifyResponse {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  dateOfBirth?: {
    day: number;
    month: number;
    year: number;
  };
  addresses?: Array<{
    address: string;
    city: string;
    postalCode: string;
    region: string;
  }>;
}

export const initializeProvePrefill = async (
  input: ProvePrefillInitializeInput
): Promise<ProvePrefillInitializeResponse> => {
  const response = await identityInstance.post('/prove/pre-fill/initialize', input);
  const authToken = response?.data?.data?.authToken ?? response?.data?.authToken;
  return { authToken };
};

export const verifyProvePrefill = async (): Promise<ProvePrefillVerifyResponse> => {
  const response = await identityInstance.post('/prove/pre-fill/verify');
  const data = (response?.data?.data ?? response?.data) as Partial<ProvePrefillVerifyResponse>;
  return {
    firstName: data?.firstName,
    lastName: data?.lastName,
    phoneNumber: data?.phoneNumber,
    dateOfBirth: data?.dateOfBirth,
    addresses: data?.addresses,
  };
};

export default {
  initializeProvePrefill,
  verifyProvePrefill,
};
